import { createTheme, alpha } from '@mui/material/styles';

const mainColor = '#2563EB';

const sharedShape = {
  borderRadius: 12,
};

const buttonOverrides = (isDark) => ({
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        textTransform: 'none',
        fontWeight: 600,
      },
      contained: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: `0 8px 20px ${alpha(mainColor, 0.28)}`,
          backgroundColor: isDark ? '#2563EB' : '#1D4ED8',
        },
      },
      outlined: {
        borderColor: isDark ? '#3B82F6' : mainColor,
        '&:hover': {
          borderColor: isDark ? '#60A5FA' : '#1D4ED8',
          backgroundColor: alpha(isDark ? '#3B82F6' : mainColor, isDark ? 0.12 : 0.04),
        },
      },
    },
  },
  MuiPaper: {
    defaultProps: { elevation: 0 },
    styleOverrides: {
      root: {
        backgroundImage: 'none',
        borderRadius: 16,
      },
    },
  },
  MuiCard: {
    defaultProps: { elevation: 0 },
    styleOverrides: {
      root: {
        borderRadius: 16,
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.08)'}`,
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: 16,
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        borderColor: alpha(isDark ? '#3B82F6' : mainColor, 0.12),
        ...(isDark ? { backgroundColor: '#1F2937' } : {}),
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: 12,
        },
      },
    },
  },
  MuiSwitch: {
    styleOverrides: {
      switchBase: {
        '&.Mui-checked': {
          color: isDark ? '#3B82F6' : mainColor,
          '& + .MuiSwitch-track': {
            backgroundColor: isDark ? '#3B82F6' : mainColor,
          },
        },
      },
    },
  },
  MuiSlider: {
    styleOverrides: {
      root: {
        color: isDark ? '#3B82F6' : mainColor,
      },
      thumb: {
        '&:hover, &.Mui-focusVisible': {
          boxShadow: `0px 0px 0px 8px ${alpha(isDark ? '#3B82F6' : mainColor, 0.16)}`,
        },
      },
    },
  },
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        scrollbarWidth: 'thin',
      },
    },
  },
});

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: mainColor,
      light: '#3B82F6',
      dark: '#1D4ED8',
      contrastText: '#ffffff',
    },
    background: {
      default: '#F5F7FB',
      paper: '#ffffff',
    },
    text: {
      primary: '#0F172A',
      secondary: '#64748B',
    },
    divider: 'rgba(15, 23, 42, 0.08)',
  },
  shape: sharedShape,
  typography: {
    fontFamily: '"Inter", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    button: { fontWeight: 600 },
  },
  components: buttonOverrides(false),
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#3B82F6',
      light: '#60A5FA',
      dark: '#2563EB',
      contrastText: '#ffffff',
    },
    background: {
      default: '#0B1220',
      paper: '#111827',
    },
    text: {
      primary: '#F8FAFC',
      secondary: '#94A3B8',
    },
    divider: 'rgba(148, 163, 184, 0.16)',
  },
  shape: sharedShape,
  typography: {
    fontFamily: '"Inter", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    button: { fontWeight: 600 },
  },
  components: buttonOverrides(true),
});

export const theme = lightTheme;
